import { useNavigate, useSearchParams } from "react-router-dom";
import { Button, Flex, Typography } from "@payping/web-components";
import useTranslator from "@/shared/translate/translator";
import { Constants as routerConstants } from "@/refund/routes";

const SuccessIcon = () => (
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M40 5C20.6719 5 5 20.6719 5 40C5 59.3281 20.6719 75 40 75C59.3281 75 75 59.3281 75 40C75 20.6719 59.3281 5 40 5ZM55.1172 28.5703L38.6641 51.3828C38.4341 51.7038 38.131 51.9653 37.7797 52.1457C37.4285 52.3261 37.0394 52.4203 36.6445 52.4203C36.2497 52.4203 35.8605 52.3261 35.5093 52.1457C35.1581 51.9653 34.855 51.7038 34.625 51.3828L24.8828 37.8828C24.5859 37.4688 24.8828 36.8906 25.3906 36.8906H29.0547C29.8516 36.8906 30.6094 37.2734 31.0781 37.9297L36.6406 45.6484L48.9219 28.6172C49.3906 27.9687 50.1406 27.5781 50.9453 27.5781H54.6094C55.1172 27.5781 55.4141 28.1562 55.1172 28.5703Z"
      fill="#85C33D"
    />
  </svg>
);

const FailIcon = () => (
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M40 5C20.6719 5 5 20.6719 5 40C5 59.3281 20.6719 75 40 75C59.3281 75 75 59.3281 75 40C75 20.6719 59.3281 5 40 5ZM52.9219 53.2969L47.7656 53.2734L40 44.0156L32.2422 53.2656L27.0781 53.2891C26.7344 53.2891 26.4531 53.0156 26.4531 52.6641C26.4531 52.5156 26.5078 52.375 26.6016 52.2578L36.7656 40.1484L26.6016 28.0469C26.5072 27.9324 26.4548 27.789 26.4531 27.6406C26.4531 27.2969 26.7344 27.0156 27.0781 27.0156L32.2422 27.0391L40 36.2969L47.7578 27.0469L52.9141 27.0234C53.2578 27.0234 53.5391 27.2969 53.5391 27.6484C53.5391 27.7969 53.4844 27.9375 53.3906 28.0547L43.2422 40.1562L53.3984 52.2656C53.4922 52.3828 53.5469 52.5234 53.5469 52.6719C53.5469 53.0156 53.2656 53.2969 52.9219 53.2969Z"
      fill="#FF4D4F"
    />
  </svg>
);

const Receipt: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { t } = useTranslator("refund.receipt");
  const isSuccessful = searchParams.get("status") === "successful";

  const handleClick = () => {
    navigate(routerConstants.wallet.url);
  };

  return (
    <Flex vertical justify="center" align="center" className="tw:h-[60vh]">
      {isSuccessful ? <SuccessIcon /> : <FailIcon />}
      <Typography.Title level={5} className="tw:mb-0! tw:mt-[29px]!">
        {isSuccessful ? t("successful") : t("fail1")}
      </Typography.Title>
      {!isSuccessful && (
        <Typography.Title level={5} className="tw:m-0!">
          {t("fail2")}
        </Typography.Title>
      )}
      <Button onClick={handleClick} className="tw:mt-[16px]!">
        {t("action")}
      </Button>
    </Flex>
  );
};
export default Receipt;
